export function TechChip({ children }) {
  return <span className="tech-chip">{children}</span>;
}
